<template>
  <div>
    <usernav></usernav>
    <el-col>
      <el-card v-show = '!success' shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          <span>注意事项</span>
        </div>
        <div>
        <ol style="padding-inline-start: 15px;">
          <li>本站秉持信息中立，不接受任何付费发布以及信息置顶。<strong style="color: #ff3399">请不要因为发布信息去升级VIP会员</strong>，信息审核和会员等级无关，我们的信息的审核标准只是需要真实、无套路、不忽悠。</li>
          <li>请勿投递良家、裸聊、欺诈类的信息，此类投递将会永久封禁你的账号和访问IP。对于恶意欺诈、泄漏他人隐私，一旦收到举报，我们会把你的用户信息以及IP提供给受害者进一步处理，请好自为之。</li>
          <li>近期屡有狼友上当受骗，对于黑中介、外围经纪、全国空降、纯上门服务这几类欺诈重灾区的信息一律不再通过，请勿浪费时间发布。</li>
          <li><span style="color:#ff3399"><strong>我们不会以任何形式去联络信息中的联系方式，更不会索要任何照片以及钱财，任何号称&ldquo;一楼一凤管理&rdquo;或者&ldquo;一楼一凤官方&rdquo;的人，都是骗子，请勿上当受骗。</strong></span></li>
          <li><span style="color:#ff3399"><strong>我们没有任何对外的微信、QQ、telegram（电报）、电报群，联系本站客服只能通过邮箱fengloukefu@gmail.com，任何通过微信、QQ、telegram（电报）、电报群跟发帖人联系的均是骗子。</strong></span></li>
          <li><span style="color:#ff3399"><strong>如果碰到索要钱财和视频、自称官方、自称审核员，请保留证据发邮件举报到fengloukefu@gmail.com，我们会对你的信息进行保护并且曝光骗子。</strong></span></li>
          <li><strong>请在发布信息的时候注意以下几个原则：</strong>
            <ul>
              <li>请负责的选择基本信息，包括年龄、价格、地区，确保信息的准确性。</li>
              <li>上传图片的信息将会被优先通过，基于隐私你可以对面部以及带有特征部位的地方马赛克处理。</li>
              <li>任何一个信息重复发布是次数低于3天一次，多次重复将不会被通过，当天重复发布的信息只会通过最早的1个。</li>
              <li>对于楼凤、经纪人以及商家，我们建议直接在详细介绍里发布课表或服务价格介绍，不要去编故事。</li>
              <li>认真填写联系方式，没有的联系方式留空，多个联系方式用空格断开，除了联系方式不要写其他任何无关内容。</li>
              <li>价格请填写最低的单次价格，如有其他套餐和价格补充在详细介绍里。</li>
            </ul>
          </li>
          <li><strong>体验报告类信息的发布指导规范</strong>
            <ul>
              <li>请认真描述体验过程，不要编故事和抄袭故事，描述不少于50个字，不要敷衍了事。</li>
              <li>请在描述的过程之后，对服务项目和价格也做一些介绍。</li>
              <li>上传图片附带马赛克合影照片并且带有&ldquo;一楼一凤&ldquo;验证&rdquo;的信息会被优先通过。</li>
            </ul>
          </li>
          <li><strong>楼凤商家类信息的发布指导规范</strong>
            <ul>
              <li>请直接发布详细的项目以及价格介绍，或者附加一些特色介绍，不要编故事。</li>
              <li>本站不接受号称全能型（什么都做、那里都有）的商家和经纪人类信息，不要浪费时间发布。</li>
              <li>上传图片附带手持&ldquo;一楼一凤&rdquo;验证的信息会被优先通过。</li>
            </ul>
          </li>
          <li><strong>一楼一凤照片验证指导</strong>
            <ul>
              <li>手持一张写有一楼一凤以及当天时间的纸张合影（隐私区域可以马赛克）。</li>
              <li>手持带有一楼一凤LOGO图片的手机画面或者纸张合影（隐私区域可以马赛克）。</li>
              <li>手持手机打开一楼一凤网站并且与之一起的自拍合影（隐私区域可以马赛克）。</li>
            </ul>
          </li>
          <li><strong>请注意，以下类型的信息不会被审核通过(定期更新)：</strong>
            <ul>
              <li>要支付定金或者车费，以及任何需要提前付费的信息；</li>
              <li>号称什么都有，什么地区都可以的信息；</li>
              <li>图片里带有联系方式截图的信息；</li>
              <li>描述内容敷衍了事，一句&ldquo;自己体验&rdquo;或&ldquo;很好&rdquo;了事的信息；</li>
              <li>没写、乱写或者忘记写联系方式的信息；</li>
              <li>标题很长和过于浮夸，刻意吸引眼球以及文不对题的信息；</li>
              <li>使用系统默认的超长微信号作为联系方式的信息；</li>
              <li>乱写单次价格或包夜价格的信息；</li>
              <li>盗取已审核信息图片或他人图片的信息；</li>
              <li>详细介绍里夹杂联系方式的信息；</li>
            </ul>
          </li>
        </ol>
          <router-link to="/help" class="navbar-nav">
            <el-button plain size="small">
              <svg-icon icon-class="rule" style="fill:#f39"></svg-icon>
              信息规则
            </el-button>
          </router-link>
          <div style="text-align: center">
            <el-button type="primary" :disabled = button @click="read_button">{{this.count}}我已阅读以上信息发布规范</el-button>
          </div>
      </div>
      </el-card>
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}" v-show = 'success'>
        <div class="G-title">
          <span>信息发布</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="title" label="信息标题" >
            <el-input v-model="ruleForm.title" autocomplete="off" placeholder="请填写你的信息标题"></el-input>
          </el-form-item>
          <el-form-item prop="cid" label="所属地区" ><br>
            <el-cascader v-model="ruleForm.cid" :options="cid_options" clearable autocomplete="off" style="width: 100%" placeholder="请选择所属地区"></el-cascader>
          </el-form-item>
          <el-form-item prop="age" label="小姐年龄" >
            <!--            <el-input v-model="ruleForm.age" autocomplete="off" placeholder="请填小姐的年龄或年龄范围"></el-input>-->
            <el-select v-model="ruleForm.age" placeholder="请选择小姐你年龄范围" style="width: 100%">
              <el-option
                v-for="item in age_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="face" label="小姐颜值" >
            <!--            <el-input v-model="ruleForm.face" autocomplete="off" placeholder="请填写小姐的颜值评价"></el-input>-->
            <el-select v-model="ruleForm.face" placeholder="请选择小姐颜值评分" style="width: 100%">
              <el-option
                v-for="item in face_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="price" label="消费水平" >
            <el-input v-model="ruleForm.price" autocomplete="off" placeholder="请填服务价格或者消费水平范围"></el-input>
          </el-form-item>
          <el-form-item prop="project" label="服务项目">
            <el-input type="textarea" :rows="3" v-model="ruleForm.project" autocomplete="off" placeholder="填写服务项目，参考：鸳鸯浴、艳舞、按摩、波推、指滑、臀推、毒龙、舌吻、环游、吹箫、六九、口爆、深喉、颜射、丝袜制服"></el-input>
          </el-form-item>
          <el-form-item prop="process" label="详细介绍">
            <el-input type="textarea" :rows="3" v-model="ruleForm.process" autocomplete="off" placeholder="详情填写整个服务体验的详细介绍，有助于审核通过"></el-input>
            <div class="p4">* 填写详细介绍将会有助于审核，过于简短将不会被审核通过。</div>
          </el-form-item>
          <el-form-item prop="QQ" label="QQ" >
            <el-input v-model="ruleForm.QQ" autocomplete="off" placeholder="请填写QQ联系方式"></el-input>
          </el-form-item>
          <el-form-item prop="wechat" label="微信" >
            <el-input v-model="ruleForm.wechat" autocomplete="off" placeholder="请填写微信联系方式"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="电话" >
            <el-input v-model="ruleForm.phone" autocomplete="off" placeholder="请填写手机联系方式"></el-input>
          </el-form-item>
          <el-form-item prop="yuni" label="与你号" >
            <el-input v-model="ruleForm.yuni" autocomplete="off" placeholder="请填写与你号联系方式"></el-input>
          </el-form-item>
          <el-form-item prop="telegram" label="Telegram" >
            <el-input v-model="ruleForm.telegram" autocomplete="off" placeholder="请填写Telegram联系方式"></el-input>
          </el-form-item>
          <el-form-item prop="address" label="地址" >
            <el-input v-model="ruleForm.address" autocomplete="off" placeholder="填写服务场所详细地址或者大概地址"></el-input>
          </el-form-item>
          <el-form-item prop="privacy" label="隐私设置" ><br>
            <el-select v-model="ruleForm.privacy" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in privacy_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item prop="type" label="信息类型" ><br>-->
          <!--            <el-radio v-model="ruleForm.radio" label="0">个人</el-radio>-->
          <!--            <el-radio v-model="ruleForm.radio" label="2">踩坑</el-radio>-->
          <!--          </el-form-item>-->
          <el-form-item prop="photo" label="照片" ><br>
            <upload @fileList="fileList"></upload>
            <div class="p4">* 上传照片，将会有助于审核通过。</div>
          </el-form-item>
          <el-form-item prop="photo" label="验证截图" ><br>
            <upload @fileList="verify"></upload>
            <div class="p4">* 必须上传沟通截图，且与其发布的联系方式要对应。</div>
            <div class="p4">* 若上传除此以外（沟通截图）的图片一律不予通过，请勿浪费时间。</div>
            <div class="p4">* 该验证截图不会被显示，审核专用。</div>
          </el-form-item>
          <el-form-item class="form-group">
            <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')">确认发布
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import upload from '../widget/upload'
import {request} from '../../network/request'
export default {
  name: 'publish',
  components: {Usernav, upload},
  mounted () {
    this.time()
  },
  created () {
    request({
      url: '/api/publish',
      method: 'get'
    }).then(res => {
      this.cid_options = res.data.data
    }).catch(err => {
      console.log(err)
    })
  },
  data () {
    return {
      button: true,
      count: 16,
      success: false,
      loading: false,
      cid_options: [],
      age_options: [{
        value: '18-20岁',
        label: '18-20岁'
      }, {
        value: '20-25岁',
        label: '20-25岁'
      }, {
        value: '25-30岁',
        label: '25-30岁'
      }, {
        value: '30-35岁',
        label: '30-35岁'
      }, {
        value: '35-40岁',
        label: '35-40岁'
      }, {
        value: '40+',
        label: '40+'
      }],
      face_options: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }, {
        value: '4',
        label: '4'
      }, {
        value: '5',
        label: '5'
      }, {
        value: '6',
        label: '6'
      }, {
        value: '7',
        label: '7'
      }, {
        value: '8',
        label: '8'
      }, {
        value: '9',
        label: '9'
      }, {
        value: '10',
        label: '10'
      }],
      privacy_options: [{
        value: '0',
        label: '匿名发布'
      }, {
        value: '1',
        label: '显示用户名'
      }],
      ruleForm: {
        radio: '0',
        title: '',
        cid: '',
        age: '',
        face: '',
        price: '',
        project: '',
        process: '',
        QQ: '',
        wechat: '',
        phone: '',
        telegram: '',
        yuni: '',
        address: '',
        privacy: '0', // 0匿名 1显示用户名
        fileList: '',
        verify: ''
      },
      rules: {
        title: [
          {required: true, message: '请填写 标题。', trigger: 'change'}
        ],
        face: [
          {required: true, message: '请选择 小姐颜值评分。', trigger: 'change'}
        ],
        cid: [
          {required: true, message: '请填写 所属地区。', trigger: 'change'}
        ],
        age: [
          {required: true, message: '请选择 小姐年龄范围。', trigger: 'change'}
        ],
        price: [
          {required: true, message: '请填写 消费水平。', trigger: 'change'}
        ],
        project: [
          {required: true, message: '请填写 服务项目。', trigger: 'change'}
        ],
        process: [
          {required: true, message: '请填写 详细介绍。', trigger: 'change'}
        ]
      }
    }
  },
  methods: {
    read_button () {
      this.success = !this.success
      window.scrollTo(0, 0)
    },
    time () {
      this.count--
      if (this.count <= 0) {
        this.count = ''
        this.button = false
      }
      setTimeout(() => {
        this.time()
      }, 1000)
    },
    verify: function (fileList) {
      // childValue就是子组件传过来的值
      this.ruleForm.verify = fileList
    },
    fileList: function (fileList) {
      // childValue就是子组件传过来的值
      this.ruleForm.fileList = fileList
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.verify) {
            this.loading = true
            let data = new URLSearchParams()
            data.append('fileList', JSON.stringify(this.ruleForm.fileList))
            data.append('verify', JSON.stringify(this.ruleForm.verify))
            data.append('title', this.ruleForm.title)
            data.append('cid', this.ruleForm.cid[1])
            data.append('age', this.ruleForm.age)
            data.append('face', this.ruleForm.face)
            data.append('price', this.ruleForm.price)
            data.append('project', this.ruleForm.project)
            data.append('process', this.ruleForm.process)
            data.append('QQ', this.ruleForm.QQ)
            data.append('wechat', this.ruleForm.wechat)
            data.append('phone', this.ruleForm.phone)
            data.append('address', this.ruleForm.address)
            data.append('privacy', this.ruleForm.privacy)
            data.append('type', this.ruleForm.radio)
            data.append('telegram', this.ruleForm.telegram)
            data.append('yuni', this.ruleForm.yuni)
            request({
              url: '/api/publish',
              method: 'post',
              data: data
            }).then(res => {
              if (res.data.status === 0) {
                this.ruleForm = this.$options.data().ruleForm
                this.$refs.ruleForm.resetFields()
                this.$message.success('提交成功')
                this.$router.replace('/usercenter')
              }
              if (res.data.status === 1) {
                this.$message.error('请不要频繁提交！')
                this.$router.replace('/usercenter')
              }
            }).catch(err => {
              console.log(err)
              this.$message.error('网络错误')
              this.loading = false
            })
          } else {
            this.$message.error('请上传验证截图')
          }
        } else {
          this.$message.warning('带*项必须填写')
        }
      })
    }
  }
}
</script>

<style scoped>
  ul{
    padding-inline-start: 15px;
  }
  li {
    line-height: 1.5rem;
    font-size: 14px;
  }
  .G-title {
    font-weight: bold;
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
    justify-content: space-between !important;
    display: flex !important;
  }
  .svg-icon {
    width: 1.1em;
    height: 1.1em;
    vertical-align: -0.15em;
    fill: currentColor;
  }
  .alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
  }
  div >>> .el-input > input{
    height: 40px;
  }
  .p4 {
    font-size: 14px;
    color: #f39;
  }
  .text-dark {
    font-weight: 600 !important;
    margin-top: .5rem !important;
    margin-bottom: .5rem !important;
    font-size: 14px;
  }
  .m2 {
    margin-bottom: .5rem;
    margin-top: .5rem;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/publish.vue